import Route from 'mewe/routes/route';

export default Route.extend({
  theme: 'group',

  templateName: 'app.group.inxed.feed',

  model: function (params, transition) {
    this._super(...arguments);

    let { to: toRouteInfo } = transition;

    const groupId = toRouteInfo.parent.params.group_id;

    this.dispatch('feed', 'openSinglePost', { scope: 'group', groupId: groupId, postItemId: params.post_id });

    return {};
  },
});
